// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: prFzY4CsJhDpFsYFo29VMf
// Component: hz7eRhzEc6

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import TextInput from "../../TextInput"; // plasmic-import: TAzASWLFePH/component
import Button from "../../Button"; // plasmic-import: MznF3tGFZjD/component

import { useScreenVariants as useScreenVariants_5VS0GwAl4 } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: -5vS0GW_al4/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_idea_hub.module.css"; // plasmic-import: prFzY4CsJhDpFsYFo29VMf/projectcss
import sty from "./PlasmicNewsLetter.module.css"; // plasmic-import: hz7eRhzEc6/css

import SearchsvgIcon from "./icons/PlasmicIcon__Searchsvg"; // plasmic-import: f42r0km3yz4/icon
import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: OZSfMt1ZAhb/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: QKCDMAfoLkN/icon
import croppedImageBusinessmanEyeglassesSittingByTableCafeUsingLaptopComputerjpgDg90DuiG4 from "./images/croppedImageBusinessmanEyeglassesSittingByTableCafeUsingLaptopComputerjpg.jpg"; // plasmic-import: DG90duiG4/picture

createPlasmicElementProxy;

export type PlasmicNewsLetter__VariantMembers = {
  invalid: "invalid";
};
export type PlasmicNewsLetter__VariantsArgs = {
  invalid?: SingleBooleanChoiceArg<"invalid">;
};
type VariantPropType = keyof PlasmicNewsLetter__VariantsArgs;
export const PlasmicNewsLetter__VariantProps = new Array<VariantPropType>(
  "invalid"
);

export type PlasmicNewsLetter__ArgsType = {
  children?: React.ReactNode;
  slot?: React.ReactNode;
};
type ArgPropType = keyof PlasmicNewsLetter__ArgsType;
export const PlasmicNewsLetter__ArgProps = new Array<ArgPropType>(
  "children",
  "slot"
);

export type PlasmicNewsLetter__OverridesType = {
  root?: p.Flex<"div">;
  img?: p.Flex<typeof p.PlasmicImg>;
  form?: p.Flex<"form">;
  emailInput?: p.Flex<typeof TextInput>;
  emailSendButton?: p.Flex<typeof Button>;
  toastPlaceholder?: p.Flex<"div">;
};

export interface DefaultNewsLetterProps {
  children?: React.ReactNode;
  slot?: React.ReactNode;
  invalid?: SingleBooleanChoiceArg<"invalid">;
  className?: string;
}

const $$ = {};

function PlasmicNewsLetter__RenderFunc(props: {
  variants: PlasmicNewsLetter__VariantsArgs;
  args: PlasmicNewsLetter__ArgsType;
  overrides: PlasmicNewsLetter__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "emailInput.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "invalid",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.invalid
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariants_5VS0GwAl4()
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root,
        { [sty.rootinvalid]: hasVariant($state, "invalid", "invalid") }
      )}
    >
      <p.Stack
        as={"div"}
        hasGap={true}
        className={classNames(projectcss.all, sty.freeBox___0Gl6)}
      >
        <p.PlasmicImg
          data-plasmic-name={"img"}
          data-plasmic-override={overrides.img}
          alt={""}
          className={classNames(sty.img)}
          displayHeight={"auto"}
          displayMaxHeight={"none"}
          displayMaxWidth={"80px"}
          displayMinHeight={"0"}
          displayMinWidth={"0"}
          displayWidth={"auto"}
          loading={"lazy"}
          src={{
            src: croppedImageBusinessmanEyeglassesSittingByTableCafeUsingLaptopComputerjpgDg90DuiG4,
            fullWidth: 5760,
            fullHeight: 3840,
            aspectRatio: undefined
          }}
        />

        <div className={classNames(projectcss.all, sty.freeBox__fd5P4)}>
          <div className={classNames(projectcss.all, sty.freeBox___9MP91)}>
            {p.renderPlasmicSlot({
              defaultContents: "Sign Up for Our Newsletter",
              value: args.children,
              className: classNames(sty.slotTargetChildren)
            })}
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__rgW2)}>
            {p.renderPlasmicSlot({
              defaultContents:
                "Get the best resources sent directly to your inbox.",
              value: args.slot,
              className: classNames(sty.slotTargetSlot)
            })}
          </div>
        </div>
      </p.Stack>
      <form
        data-plasmic-name={"form"}
        data-plasmic-override={overrides.form}
        className={classNames(projectcss.all, sty.form)}
      >
        <TextInput
          data-plasmic-name={"emailInput"}
          data-plasmic-override={overrides.emailInput}
          className={classNames("__wab_instance", sty.emailInput, {
            [sty.emailInputinvalid]: hasVariant($state, "invalid", "invalid")
          })}
          onChange={(...eventArgs) => {
            p.generateStateOnChangeProp($state, ["emailInput", "value"])(
              (e => e.target?.value).apply(null, eventArgs)
            );
          }}
          placeholder={"Enter Email"}
          required={true}
          type={"email"}
          value={
            p.generateStateValueProp($state, ["emailInput", "value"]) ?? ""
          }
        />

        <Button
          data-plasmic-name={"emailSendButton"}
          data-plasmic-override={overrides.emailSendButton}
          className={classNames("__wab_instance", sty.emailSendButton, {
            [sty.emailSendButtoninvalid]: hasVariant(
              $state,
              "invalid",
              "invalid"
            )
          })}
          color={"green"}
        >
          {"Join"}
        </Button>
      </form>
      <div
        data-plasmic-name={"toastPlaceholder"}
        data-plasmic-override={overrides.toastPlaceholder}
        className={classNames(projectcss.all, sty.toastPlaceholder)}
      />
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "img",
    "form",
    "emailInput",
    "emailSendButton",
    "toastPlaceholder"
  ],
  img: ["img"],
  form: ["form", "emailInput", "emailSendButton"],
  emailInput: ["emailInput"],
  emailSendButton: ["emailSendButton"],
  toastPlaceholder: ["toastPlaceholder"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  img: typeof p.PlasmicImg;
  form: "form";
  emailInput: typeof TextInput;
  emailSendButton: typeof Button;
  toastPlaceholder: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicNewsLetter__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicNewsLetter__VariantsArgs;
    args?: PlasmicNewsLetter__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicNewsLetter__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicNewsLetter__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicNewsLetter__ArgProps,
          internalVariantPropNames: PlasmicNewsLetter__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicNewsLetter__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicNewsLetter";
  } else {
    func.displayName = `PlasmicNewsLetter.${nodeName}`;
  }
  return func;
}

export const PlasmicNewsLetter = Object.assign(
  // Top-level PlasmicNewsLetter renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    img: makeNodeComponent("img"),
    form: makeNodeComponent("form"),
    emailInput: makeNodeComponent("emailInput"),
    emailSendButton: makeNodeComponent("emailSendButton"),
    toastPlaceholder: makeNodeComponent("toastPlaceholder"),

    // Metadata about props expected for PlasmicNewsLetter
    internalVariantProps: PlasmicNewsLetter__VariantProps,
    internalArgProps: PlasmicNewsLetter__ArgProps
  }
);

export default PlasmicNewsLetter;
/* prettier-ignore-end */
